import { ChipGroup } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  eventTypes,
  objectTypes,
  useTracker,
} from "@newsela/snitch";

import { ContentHeaderSortByButton } from "@/search/NewSearchPageMVP/ContentTypeFilter/ContentHeaderSortByButton";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { useSearchAdminPermissions } from "../provider/hooks";
import {
  chipGroupRootCss,
  contentTypesVisibilityCss,
} from "./ContentTypeFilter.styles";
import { ContentTypeFilterChips } from "./ContentTypeFilterChips";

export const ContentTypeFilter = () => {
  const {
    getters: { validQueryParams },
    handlers: {
      getSearchParamValues,
      toggleSearchParamValue,
      deleteSearchParamValues,
    },
  } = useSearchPageContext();

  // Using a custom tracking instead of withTrackerEvent to avoid accessibility issues and also the withTrackerEvent with Chip component doesn't work properly
  const { trackAction, getEventName } = useTracker();

  const { blockActionAndShowConfirmationModal, blockFilterChanges } =
    useSearchAdminPermissions();

  const contentTypeValues =
    validQueryParams[AgathaSchemaParamsEnum.content_types]?.items?.values;

  const handleChipSelection = (_: unknown, value: string) => {
    trackAction({
      event_name: getEventName(
        objectTypes.content,
        actionPrefixes.initiate,
        actionNames.filter,
      ),
      event_type: eventTypes.click,
      dimension_properties: {
        description: `Filter search by ${value} Content Type`,
      },
    });

    if (blockFilterChanges) {
      blockActionAndShowConfirmationModal();
      return;
    }

    if (value === "all") {
      deleteSearchParamValues(AgathaSchemaParamsEnum.content_types);
      return;
    }
    toggleSearchParamValue(AgathaSchemaParamsEnum.content_types, value);
  };

  if (!contentTypeValues) return null;

  return (
    <div css={contentTypesVisibilityCss}>
      <ChipGroup
        __cssFor={chipGroupRootCss}
        chipType={ChipGroup.chipTypes.filter}
        groupName="selectedFilters"
        onChipEvent={handleChipSelection}
        size={ChipGroup.chipSizes.medium}
      >
        <ContentTypeFilterChips
          activeChips={getSearchParamValues(
            AgathaSchemaParamsEnum.content_types,
          )}
          contentTypeValues={contentTypeValues}
        />
      </ChipGroup>

      <ContentHeaderSortByButton />
    </div>
  );
};
